import React, {useEffect, useState} from 'react';
import './forgotPassword.scss';
import {Formik} from "formik";
import EMAIL_ICON from "assets/icons/email_icon.svg";
import {Button, InputField, Loading} from "components";
import * as Yup from "yup";
import useForgetPassword from "../../../operations/mutations/useForgetPassword";
import {useNavigate} from "react-router-dom";

const ERROR_ICON = <svg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M1.00195 1.00024L11.0004 10.9987' stroke='white' stroke-width='1.42857' stroke-linecap='round'/>
    <path d='M10.9985 1L1.00012 10.9984' stroke='white' stroke-width='1.42857' stroke-linecap='round'/>
</svg>;

export const ForgotPasswordFormValidation = Yup.object().shape({
    email: Yup.string().required('Email is required').email('Invalid email address'),
})

const ForgotPassword = () => {
    const {mutateAsync, isError, isLoading} = useForgetPassword();
    const navigate = useNavigate();
    const [isForgetError, setForgetError] = useState(false);
    const [responseMessage, setResponseMessage] = useState<string>(
        'A connectivity issue has occurred. Please check your connection and try again.'
    );

    useEffect(() => {
        setForgetError(isError);
    }, [isError]);

    const resetPassword = () => {
        console.log('reset Password')
    }

    const onSubmit = async (values: any, {setSubmitting}: any) => {

        await mutateAsync(values)
            .then(response => {
                setResponseMessage(response.data.msg)
                navigate('/reset',{state:{
                    email:values.email
                    }})
            })
            .catch((err) => {
                setResponseMessage(err.response.data.message)
            })
        setSubmitting(false);
    }
    return (
        <div className={'forgot-password'}>
            <h1>Forgot Password</h1>
            <p>Please enter your email to reset your password.</p>
            {isForgetError &&
            <div
                className='forgot-password_error'>
                <div className='forgot-password_error_circle' onClick={() => setForgetError(false)}>
                    {ERROR_ICON}
                </div>
                <h1>Oops!</h1>
                <p>{responseMessage}</p>
            </div>}
            {isLoading && (
                <div className={'forgot-password_loading'}>
                    <Loading/>
                </div>
            )}
            <Formik
                validateOnMount={false}
                initialValues={{email: ""}}
                validationSchema={ForgotPasswordFormValidation}
                onSubmit={onSubmit}
            >
                {({handleSubmit, handleChange, values, handleBlur, errors, touched}) => (
                    <form onSubmit={handleSubmit}>
                        <div>
                            <InputField
                                type="text"
                                classname="signup__input"
                                placeholder={"Email Address"}
                                name="email"
                                onblur={handleBlur}
                                error={errors.email && touched.email}
                                onchange={handleChange}
                                message={errors.email && touched.email && errors.email}
                                inputValue={values.email}
                                image={EMAIL_ICON}
                            />

                            <Button type={"primary"} isSubmit={true} text={"Send Link"}/>

                        </div>
                    </form>
                )}
            </Formik>
            <p className={'tertiary_cta'}>Didn’t receive the email? <span
                onClick={resetPassword}>Resend</span></p>

        </div>
    );
};

export default ForgotPassword;
